var map = {
	"./Vitra_Close.svg": 1404,
	"./Vitra_Collection.svg": 1405,
	"./Vitra_Down.svg": 1406,
	"./Vitra_Highlights.svg": 1407,
	"./Vitra_Kids.svg": 1408,
	"./Vitra_Menu.svg": 1409,
	"./Vitra_MenuOpen.svg": 1410,
	"./Vitra_MuseumLogo.svg": 589,
	"./Vitra_Next.svg": 590,
	"./Vitra_Previous.svg": 1411,
	"./Vitra_ReferenceNumber.svg": 1412,
	"./Vitra_Save.svg": 1413,
	"./Vitra_SavePDF.svg": 1414,
	"./Vitra_Search.svg": 1415,
	"./Vitra_Share.svg": 1416,
	"./Vitra_Up.svg": 1417
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 591;



//////////////////
// WEBPACK FOOTER
// ./images/icons ^\.\/.*$
// module id = 591
// module chunks = 0